import { z } from 'zod';
import { FOLLOW_UP_CHANNELS, FOLLOW_UP_OUTCOMES } from '../enums.js';
import { optionalText } from './common.js';
/**
 * The heart of MEFOSA's daily job. Their current CRM is a spreadsheet of
 * exactly this: who was contacted, when, how, what happened, what is next.
 */
export const followUpInputSchema = z.object({
    companyId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    dealId: z.string().uuid().optional(),
    channel: z.enum(FOLLOW_UP_CHANNELS).default('call'),
    outcome: z.enum(FOLLOW_UP_OUTCOMES).default('reached'),
    occurredOn: z.string().date(),
    note: z.string().trim().min(1, 'What happened?').max(4000),
    /** Drives the "what do I do today" list. */
    nextActionOn: z.string().date().optional(),
    nextActionNote: optionalText,
}).refine((v) => Boolean(v.companyId ?? v.contactId ?? v.dealId), { message: 'A follow-up must be attached to a company, contact or deal' });
//# sourceMappingURL=followUp.js.map